import { type PropsWithChildren } from 'react';
import styles from './Instruction.module.css';

interface InstructionProps extends PropsWithChildren {}

export function Instruction(props: InstructionProps) {
  const { children } = props;

  return <ol className={styles.root}>{children}</ol>;
}
